module.exports = __webpack_public_path__ + "static/media/hitchhiker-badge.acf0377d.svg";